import { render } from "./CoursePreview.vue?vue&type=template&id=535afed8&scoped=true"
import script from "./CoursePreview.vue?vue&type=script&lang=js"
export * from "./CoursePreview.vue?vue&type=script&lang=js"

import "./CoursePreview.vue?vue&type=style&index=0&id=535afed8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535afed8"]])

export default __exports__